import React from "react";

import {Route, Routes} from "react-router-dom";
import BizMain from "page/user/biz/Main";
import BizDetail from "page/user/biz/Detail";

import UserManagerMain from "page/user/manager/Main";
import UserMemberMain from "page/user/member/Main";
import UserMemberDetail from "page/user/member/Detail";
import UserDropMain from "page/user/drop/Main";
import UserDropDetail from "page/user/drop/Detail";
import UserMembershipCancelMain from "page/user/membershipCancel/Main";
import UserTutorialStatistics from "page/user/tutorial/Main";

import PaymentHistoryMain from "page/payment/history/Main"

import CertMain from "page/cert/Main"

import BizContract from "page/user/biz/contract/List";
import BizContractDetail from "page/user/biz/contract/Detail";
import BizExpectedVat from "page/user/biz/expected/vat/List";
import BizExpectedVatEdit from "page/user/biz/expected/vat/Edit";
import BizExpectedIncome from "page/user/biz/expected/income/List";
import BizExpectedIncomeEdit from "page/user/biz/expected/income/Edit";

import PolicySupportMain from "page/policySupport/Main";
import PolicySupportEdit from "page/policySupport/Edit";
import PolicySupportKeyword from "page/policySupport/Keyword";
import SalaryMain from "page/salary/List";
import SalaryDetail from "page/salary/Detail";

import AppVersion from "page/app/AppVersion";
import KnowledgeMain from "page/app/knowledge/Main";
import KnowledgeDetail from "page/app/knowledge/Detail";
import PopupMain from "page/app/popup/Main";
import PopupDetail from "page/app/popup/Detail";
import NoticeMain from "page/app/notice/Main";
import NoticeDetail from "page/app/notice/Detail";
import Edi0001LogMain from "page/insurance/log/edi0001/Main"
import Edi0002LogMain from "page/insurance/log/edi0002/Main"
import Edi0003LogMain from "page/insurance/log/edi0003/Main"
import Edi0004LogMain from "page/insurance/log/edi0004/Main"

import FcmMain from "page/push/fcm/Main";
import PushMessageMain from "page/push/message/Main";
import PushMessageDetail from "page/push/message/Detail";
import PushMessageSendHistoryMain from "page/push/message/history/Main";
import PushMessageSendHistoryDetail from "page/push/message/history/Detail";
import PushTriggerMain from "page/push/trigger/Main";
import PushTriggerDetail from "page/push/trigger/Detail";


function App() {
  return (
      <div className="App">
          <Routes>
              <Route path="/page/user/biz/main" element={<BizMain />} />
              <Route path="/page/user/biz/detail" element={<BizDetail />} />
              <Route path="/page/user/manager/main" element={<UserManagerMain />} />
              <Route path="/page/user/member/main" element={<UserMemberMain />} />
              <Route path="/page/user/member/detail" element={<UserMemberDetail />} />
              <Route path="/page/user/drop/main" element={<UserDropMain />} />
              <Route path="/page/user/drop/detail" element={<UserDropDetail />} />
              <Route path="/page/user/membership-cancel/main" element={<UserMembershipCancelMain />} />
              <Route path="/page/user/tutorial/main" element={<UserTutorialStatistics />} />

              <Route path="/page/push/fcm/main" element={<FcmMain />} />
              <Route path="/page/push/message/main" element={<PushMessageMain />} />
              <Route path="/page/push/message/detail" element={<PushMessageDetail />} />
              <Route path="/page/push/message/history/main" element={<PushMessageSendHistoryMain />} />
              <Route path="/page/push/message/history/detail" element={<PushMessageSendHistoryDetail />} />
              <Route path="/page/push/trigger/main" element={<PushTriggerMain />} />
              <Route path="/page/push/trigger/detail" element={<PushTriggerDetail />} />

              <Route path="/page/payment/history/main" element={<PaymentHistoryMain />} />

              <Route path="/page/cert/main" element={<CertMain />} />

              <Route path="/page/biz/contract/list" element={<BizContract />} />
              <Route path="/page/biz/contract/detail" element={<BizContractDetail />} />
              <Route path="/page/biz/expected/vat/list" element={<BizExpectedVat />} />
              <Route path="/page/biz/expected/vat/edit" element={<BizExpectedVatEdit />} />
              <Route path="/page/biz/expected/income/list" element={<BizExpectedIncome />} />
              <Route path="/page/biz/expected/income/edit" element={<BizExpectedIncomeEdit />} />

              <Route path="/page/policy-support/main" element={<PolicySupportMain />} />
              <Route path="/page/policy-support/edit" element={<PolicySupportEdit />} />
              <Route path="/page/policy-support/keyword" element={<PolicySupportKeyword />} />
              <Route path="/page/salary/main" element={<SalaryMain />} />
              <Route path="/page/salary/detail" element={<SalaryDetail />} />

              <Route path="/page/app/version" element={<AppVersion />} />
              <Route path="/page/app/knowledge/main" element={<KnowledgeMain />} />
              <Route path="/page/app/knowledge/detail" element={<KnowledgeDetail />} />
              <Route path="/page/app/popup/main" element={<PopupMain />} />
              <Route path="/page/app/popup/detail" element={<PopupDetail />} />
              <Route path="/page/app/notice/main" element={<NoticeMain />} />
              <Route path="/page/app/notice/detail" element={<NoticeDetail />} />

              <Route path="/page/insurance/log/edi0001/main" element={<Edi0001LogMain />} />
              <Route path="/page/insurance/log/edi0002/main" element={<Edi0002LogMain />} />
              <Route path="/page/insurance/log/edi0003/main" element={<Edi0003LogMain />} />
              <Route path="/page/insurance/log/edi0004/main" element={<Edi0004LogMain />} />
          </Routes>
      </div>
  );
}

export default App;
